import {StoreBase, StoreDataType} from "shared/core/Store/StoreBase";
import {ConditionOptionsBase} from "../../Dialogs/TemplateSettings/Conditions/Core/ConditionBuilder";

export class Formula extends StoreBase{
    Name:string;
    @StoreDataType(Object)
    Compiled;
    @StoreDataType(Object)
    Code;

    protected LoadDefaultValues() {
        this.Name='';
        this.Compiled=null;
        this.Code=null;
    }


}

export class FieldSettingsOptions extends StoreBase{
    Id:string;
    MappedTo:string;
    @StoreDataType(String)
    CheckValues:string[];
    @StoreDataType(Formula)
    Formulas:Formula[];

    protected LoadDefaultValues() {
        this.Id='';
        this.MappedTo='';
        this.CheckValues=[];
        this.Formulas=[];
    }
}

export class AttachToEmailOptions extends StoreBase{
    Id:string;

    protected LoadDefaultValues() {
        this.Id='';
    }
}

export class AdditionalSettings extends StoreBase{
    public Font:string;
    protected LoadDefaultValues() {
        this.Font='';
    }

}


export class DocumentManagerOptions extends StoreBase{
    FormId:string;
    TemplateName:string;
    Id:number;
    PDFURL:string;
    PDFName:string;
    @StoreDataType(FieldSettingsOptions)
    FieldSettings:FieldSettingsOptions[];
    @StoreDataType(Object)
    PDFFileName:any;
    @StoreDataType(AttachToEmailOptions)
    AttachToEmail:AttachToEmailOptions[];
    SkipCondition:ConditionOptionsBase;
    @StoreDataType(Object)
    AdditionalSettings:AdditionalSettings;
    DateFormat:string;
    protected LoadDefaultValues() {
        this.Id=0;
        this.FormId='';
        this.DateFormat='Y-m-j'
        this.PDFURL='';
        this.PDFName='';
        this.TemplateName='';
        this.FieldSettings=[];
        this.AttachToEmail=[];
        this.AdditionalSettings= new AdditionalSettings().Merge();
        this.SkipCondition=new ConditionOptionsBase().Merge();
        this.PDFFileName={
            document: {
                nodes: [
                    {
                        object: 'block',
                        type: 'paragraph',
                        nodes: [
                            {
                                object: 'text',
                                leaves: [
                                    {
                                        text: "Document",
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        };
    }
}